export default __webpack_public_path__ + "static/3-f32d425e6b089d46f2741d74aeafada7.jpg";